module.exports = __webpack_public_path__ + "static/img/3.b4c0ca1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/eng/3.png
// module id = l+u9
// module chunks = 0